import { ServerStateKeysEnum } from '@/common/apis/serverStateKeysEnum';
import { useQuery } from '@tanstack/react-query';
import { fetchDoctorRate } from './rateDoctor';

export interface Rate {
  slug: string;
}

/** Same envelope as legacy NocoDB `GET /ravi/v1/rate?where=` (`list[0]`). */
export const rate = async (params: Rate) => {
  const data = await fetchDoctorRate(params.slug);
  if (data && Array.isArray((data as { list?: unknown }).list)) {
    return data;
  }
  return { list: [data] };
};

export const useRate = (params: Rate, options?: any) => {
  return useQuery([ServerStateKeysEnum.Rate, params], () => rate(params), options);
};
